import React, { useRef, useState } from "react";
import { useHistory, Link } from "react-router-dom";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { CircularProgress } from "@mui/material";

import { registerUser } from "../../actions/authAction.js";
import Recaptcha, { isRecaptchaEnabled } from "../component/common/Recaptcha";

import "./register.css";

const Register = ({ registerUser }) => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [check_1, setCheck_1] = useState(false);
  const [clickStatus, setClickStatus] = useState(false);
  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const recaptchaRef = useRef(null);

  let history = useHistory();

  const toastHandler = (state, msg) => {
    if (state === "success") {
      toast.success(msg, {
        position: "top-center",
        containerId: "main",
        autoClose: 2500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
    if (state === "error") {
      toast.error(msg, {
        position: "top-center",
        containerId: "main",
        autoClose: 2500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  const register = () => {
    if (
      firstName.length &&
      lastName.length &&
      password.length &&
      email.length
    ) {
      if (password === confirmPassword) {
        // if (check_1 && check_2) {
        if (check_1) {
          if (isRecaptchaEnabled() && !recaptchaToken) {
            toastHandler("error", "Please confirm you're not a robot.");
            return;
          }
          var userData = {
            firstName: firstName,
            lastName: lastName,
            email: email,
            password: password,
            recaptchaToken,
          };
          setClickStatus(true);
          registerUser(userData, history, setClickStatus, () => {
            // A captcha token is single-use — clear it so a retry after a
            // failed sign-up gets a fresh one.
            recaptchaRef.current?.reset();
            setRecaptchaToken(null);
          });
        } else {
          toastHandler("error", "Please accept policies before joining.");
        }
      } else {
        toastHandler("error", "Those passwords didn’t match. Try again.");
      }
    } else {
      toastHandler("error", "Please fill all the fields!");
    }
  };

  return (
    <div className="register-form-container flex-1">
      <form className="register-form">
          <div className="register-form-content">
            <p className="register-text-login">Join The Community</p>

            <p className="register-text mb-4">
              Join <span className="text-[#1cc400]">TRADE</span>
              <span>IT</span>
              <span className="text-[#1cc400]">FWD</span>
              <sup className="text-[10px] -top-2 text-[#1cc400]">TM</sup> to get
              free services in exchange for sharing yours!
            </p>

            <p className="text-center text-[13px] font-semibold text-gray-600 mb-4">
              Please tell us your name and create a log-in.
            </p>

            <div className="form-group mt-3">
              <input
                type="text"
                className="form-control !py-2.5 rounded-xl"
                placeholder="First Name"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
              />
            </div>
            <div className="form-group mt-3">
              <input
                type="text"
                className="form-control !py-2.5 rounded-xl"
                placeholder="Last Name"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
              />
            </div>
            <div className="form-group mt-3">
              <input
                type="email"
                className="form-control !py-2.5 rounded-xl"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="form-group mt-3">
              <input
                type="password"
                className="form-control !py-2.5 rounded-xl "
                placeholder="Password"
                value={password}
                autoComplete="new-password"
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            <div className="form-group mt-3">
              <input
                type="password"
                className="form-control !py-2.5 rounded-xl "
                placeholder="Confirm Password"
                value={confirmPassword}
                autoComplete="confirm-password"
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
            </div>

            <div className="form-group mt-4 !mb-2">
              <p className="text-[13px] font-semibold text-gray-700 mb-2">Terms and Conditions</p>
              <div className="grid grid-cols-12">
                <div className="col-span-1">
                  <input
                    type="checkbox"
                    checked={check_1}
                    onChange={(e) => setCheck_1(e.target.checked)}
                    className="w-4 h-4 m-1"
                  />
                </div>
                <div className="col-span-11">
                  <label className="register-text-me !p-0">
                    I accept the <span className="text-[#1cc400]">TRADE</span>
                    <span>IT</span>
                    <span className="text-[#1cc400]">FWD</span>
                    <sup className="text-[10px] -top-2 text-[#1cc400]">TM</sup>
                    {" "}
                    <Link
                      to="/terms-condition"
                      className="text-main whitespace-nowrap transition-all duration-all text-[13px] hover:underline"
                    >
                      Terms & Conditions
                    </Link>{" "}
                    <span>and</span>
                    {" "}
                    <Link
                      to="/privacy-policy"
                      className="text-main whitespace-nowrap transition-all duration-all text-[13px] hover:underline"
                    >
                      Privacy Policy
                    </Link>
                  </label>
                </div>
              </div>
            </div>

            <p className="text-[11px] text-gray-500 italic mt-3 text-center">
              <span className="text-[#1cc400] font-semibold">TRADE</span>
              <span className="font-semibold">IT</span>
              <span className="text-[#1cc400] font-semibold">FWD</span>
              <sup className="text-[#1cc400] font-semibold" style={{ fontSize: "9px", top: "-0.8em" }}>TM</sup>
              {" "}does not use marketing cookies and does not sell your data.
            </p>

            <Recaptcha ref={recaptchaRef} onChange={setRecaptchaToken} />

            <div className="form-group mt-3 btn-center">
              <button
                type="button"
                className="btn btn-success btn-login text-white"
                disabled={clickStatus}
                onClick={register}
              >
                {clickStatus ? (
                  <span className="inline-flex items-center justify-center gap-2">
                    <CircularProgress size={18} sx={{ color: "white" }} />
                    Joining...
                  </span>
                ) : (
                  "JOIN NOW"
                )}
              </button>
            </div>
            <br />
          </div>
        </form>
    </div>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors,
});

export default connect(mapStateToProps, { registerUser })(Register);
